import AppService from "./app-service"

export default class RaceService extends AppService {

  constructor() {
    super({ path: "races" })
  }
}